import { NavigationHook } from '@msdk/common'
import { matchPath, NavigateFunction } from 'react-router-dom'

export function navigateToLink(
  link: string | undefined,
  isRelativeToTenant: boolean,
  sitemap: string,
  tenant: string,
  navigate: NavigationHook,
  reactNavigate: NavigateFunction,
  additionalCtx?: Record<string, string>,
) {
  if (!link) {
    return
  }

  if (link.startsWith('/')) {
    link = link.substring(1, link.length)
  }
  link = '/' + link

  if (isRelativeToTenant) {
    const relativeUrl = new URL(`${link}`, window.location.origin)

    if (relativeUrl.searchParams.has('s')) {
      // use context from link if exists
      reactNavigate(`/${tenant}/${sitemap}${link}`)
      return
    }

    navigate(
      relativeUrl.pathname.substring(1, relativeUrl.pathname.length),
      undefined,
      additionalCtx,
      relativeUrl.searchParams,
    )
    return
  }

  window.open(link, '_blank')
}

export function getAdditionalContextFromLink(link: string | undefined): Record<string, string> | undefined {
  if (!link) {
    return
  }

  // matchPath needs only the path. Remove query parameters and fragments so they
  // are not included in the record ID.
  const [pathname] = link.split(/[?#]/)

  // Match the pathname against the expected /:entityName/:moduleName/:id pattern.
  // Tenant and sitemap are missing because navigateToLink adds them later.
  const match = matchPath(':entityName/:moduleName/:id', pathname)
  const { entityName, id: entityId } = match?.params ?? {}

  // Add context only for an existing record; avoid Create routes.
  if (!entityName || !entityId || entityId.toLowerCase() === 'create') {
    return
  }

  // Add the record ID to the URL context, as entity-list navigation does.
  return { [entityName]: entityId }
}
